import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Shield = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 6C20.488 6 16.712 2.288 16.712 2.288C16.537 2.113 16.287 2 15.999 2C15.711 2 15.474 2.112 15.286 2.288C15.286 2.288 11.524 6 6.99902 6C6.44902 6 5.99902 6.45 5.99902 7V19C5.99902 21.387 7.63702 23.95 10.861 26.637C13.161 28.55 15.424 29.812 15.511 29.862C15.661 29.949 15.824 29.987 15.999 29.987C16.174 29.987 16.337 29.949 16.486 29.862C16.586 29.812 18.849 28.549 21.136 26.637C24.361 23.949 25.999 21.375 25.999 19V7C25.999 6.45 25.549 6 24.999 6H25ZM24 19C24 22.387 18.613 26.288 16 27.85C13.387 26.3 8.00002 22.4 8.00002 19V7.95C11.688 7.6 14.688 5.437 16 4.338C17.313 5.438 20.313 7.601 24 7.95V19Z" />
	</svg>
);

export default Shield;
